module.exports = __webpack_public_path__ + "img/xddxx.39ade927.png";